export const id = {
    LEFT: 'Kiri: Pindah ke hari sebelumnya.',
    RIGHT: 'Kanan: Pindah ke hari berikutnya.',
    DOWN: 'Down: Pindah ke baris berikutnya.',
    UP: 'Up: Pindah ke baris sebelumnya.',
    PGUP: 'PgUp: Memindahkan dengan bulan sebelumnya.',
    PGDOWN: 'PgDown: Pindah ke bulan berikutnya.',
    HOME: 'Home: Pindah ke tahun sebelumnya.',
    END: 'End: Pindah ke tahun berikutnya.',
    ESC: 'Esc/Hari ini/close: Menutup kalender.',
    TITLE: 'Keyboard Petunjuk'
};
